module.exports = __webpack_public_path__ + "static/media/gaurav_wawdhane.03772a71.jpg";